import { useLayoutEffect, useRef } from 'react';

export default function useFocusDatepickerOnMount(initialValue = null) {
  const ref = useRef(initialValue);

  useLayoutEffect(() => {
    if (ref.current && ref.current.setFocus) {
      ref.current.setFocus();
    }
  }, []);

  return ref;
}
